import { render, staticRenderFns } from "./ViewBankDetails.vue?vue&type=template&id=cb300b34&scoped=true"
import script from "./ViewBankDetails.vue?vue&type=script&lang=js"
export * from "./ViewBankDetails.vue?vue&type=script&lang=js"
import style0 from "./ViewBankDetails.vue?vue&type=style&index=0&id=cb300b34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb300b34",
  null
  
)

export default component.exports